// Subcollection tile row (snippets/ec-subcollection-row.liquid).
// Desktop: the glass arrow scrolls the row by one view and hides at the end. Phones swipe
// (the arrow is hidden with CSS). Scroll snapping keeps a tile edge at the start of the row.

class EcSubcollectionRow extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-ec-subrow-list]')
    this.arrow = this.querySelector('[data-ec-subrow-next]')
    if (!this.list || !this.arrow) return

    this.abortController = new AbortController()
    const options = { signal: this.abortController.signal }
    this.update = this.update.bind(this)

    this.arrow.addEventListener('click', () => this.next(), options)
    this.list.addEventListener('focusin', (evt) => this.reveal(evt.target), options)
    this.list.addEventListener('scroll', this.update, { ...options, passive: true })
    this.resizeObserver = new ResizeObserver(this.update)
    this.resizeObserver.observe(this.list)
    this.update()
  }

  disconnectedCallback() {
    this.abortController?.abort()
    this.resizeObserver?.disconnect()
  }

  next() {
    this.list.scrollBy({ left: this.list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  }

  // Keyboard focus on a half-visible tile: scroll to a snap position where the whole tile shows
  // (the browser's own scroll-into-view can be pulled back by scroll snapping)
  reveal(target) {
    const item = target.closest('.ec-subrow__item')
    if (!item) return
    const list = this.list.getBoundingClientRect()
    const box = item.getBoundingClientRect()
    if (box.left >= list.left - 1 && box.right <= list.right + 1) return
    // A tile's left edge is always a snap position, so the row stays there
    this.list.scrollTo({ left: item.offsetLeft - this.list.offsetLeft, behavior: 'auto' })
  }

  // The arrow shows only while there is more of the row to the right
  update() {
    const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2
    const wasFocused = document.activeElement === this.arrow
    this.arrow.hidden = atEnd
    // Keyboard users keep their place when the arrow disappears at the end
    if (atEnd && wasFocused) {
      const tiles = this.list.querySelectorAll('.ec-subrow__tile')
      tiles[tiles.length - 1]?.focus({ preventScroll: true })
    }
  }
}

if (!customElements.get('ec-subcollection-row')) {
  customElements.define('ec-subcollection-row', EcSubcollectionRow)
}
